export default __webpack_public_path__ + "images/3d27f24b5722603b60668257d49b65e6.png";